import { render, staticRenderFns } from "./grayConfigHis.vue?vue&type=template&id=f000052a&scoped=true&"
import script from "./grayConfigHis.vue?vue&type=script&lang=js&"
export * from "./grayConfigHis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f000052a",
  null
  
)

export default component.exports